import { render, staticRenderFns } from "./tool-bar.vue?vue&type=template&id=6dec24d2&scoped=true"
import script from "./tool-bar.vue?vue&type=script&lang=js"
export * from "./tool-bar.vue?vue&type=script&lang=js"
import style0 from "./tool-bar.vue?vue&type=style&index=0&id=6dec24d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec24d2",
  null
  
)

export default component.exports